import { PracticeAnalyticsTypes } from '@frontend/api-analytics';
import { AnalyticsUtils } from '@frontend/analytics-shared';
import { getMockProcedures } from './procedures';
import { requiredPatientInfoFields } from './shared-helpers';

export const hygieneTreatmentPlanPatientsDetails = (): PracticeAnalyticsTypes.PatientInfo[] =>
  AnalyticsUtils.demoDataUtils.generateRandomUserNames(15).map(({ firstName, lastName }, id) => {
    const mockProcedures = getMockProcedures(AnalyticsUtils.demoDataUtils.generateRandomBoolean());
    const amount = mockProcedures.reduce((acc: number, cur) => acc + cur.procedureAmount, 0);

    return {
      ...requiredPatientInfoFields,
      diagnosed: AnalyticsUtils.demoDataUtils.generateRandomDate(),
      FirstName: firstName,
      id: `${id}`,
      LastName: lastName,
      MobilePhone: AnalyticsUtils.demoDataUtils.generateRandomPhoneNumber(),
      procedures: mockProcedures,
      productionAmount: amount,
      providerFirstName: '',
      providerLastName: '',
      providers: '',
    };
  });

export const hygieneTreatmentPlan = (): PracticeAnalyticsTypes.HygieneTreatmentPlanResponse => {
  const totalAcceptedHygiene = AnalyticsUtils.demoDataUtils.generateRandomInt(150, 180);

  return {
    location: {
      hygieneTreatmentPlan: {
        benchmarks: [
          {
            value: 0.38,
            label: 'Top Diagnosed',
          },
          {
            value: 0.75,
            label: 'Top Accepted',
          },
        ],
        details: {
          patients: hygieneTreatmentPlanPatientsDetails(),
        },
        totals: {
          accepted: AnalyticsUtils.demoDataUtils.generateRandomInt(50, 100),
          acceptedPercent: Math.random() * (0.6 - 0.8) + 0.8,
          diagnosed: AnalyticsUtils.demoDataUtils.generateRandomInt(100, 200),
          diagnosedPercent: Math.random() * (0.5 - 0.2) + 0.2,
          qualifiedVisits: AnalyticsUtils.demoDataUtils.generateRandomInt(200, 300),
          unscheduledTreatment: AnalyticsUtils.demoDataUtils.generateRandomInt(500, 1000),
        },
      },
      industryAvg: {
        totals: {
          totalAcceptedHygiene,
          totalDiagnosedHygiene: totalAcceptedHygiene + AnalyticsUtils.demoDataUtils.generateRandomInt(10, 30),
          totalUnscheduledTreatmentHygiene: AnalyticsUtils.demoDataUtils.generateRandomInt(500, 1000),
        },
      },
    },
  };
};
